var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox=False, Size=17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 0C1.90279 0 0 1.90279 0 4.25V12.75C0 15.0972 1.90279 17 4.25 17H12.75C15.0972 17 17 15.0972 17 12.75V4.25C17 1.90279 15.0972 0 12.75 0H4.25ZM4.675 1.275C2.79723 1.275 1.275 2.79723 1.275 4.675V12.325C1.275 14.2028 2.79723 15.725 4.675 15.725H12.325C14.2028 15.725 15.725 14.2028 15.725 12.325V4.675C15.725 2.79723 14.2028 1.275 12.325 1.275H4.675Z",
    fill: "#0054EC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxIcon);
export default __webpack_public_path__ + "static/media/checkBoxIcon.8fdc352380938c93e0a3073bd2d388ff.svg";
export { ForwardRef as ReactComponent };